import React from 'react'
import { Link } from 'react-router-dom'

const Resources = ({resources}) => {
  return (
     <div className="content-section">
    {resources.map((resource, index) => {
  const fileName = resource.file.split('/').pop();

  return (
    <div
      key={index}
      style={{
        margin: '10px 0',
        padding: '12px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
    >
      <Link
        to={resource.file}
        target="_blank"
        style={{
          color: '#1a73e8',
          textDecoration: 'none',
          fontWeight: '500',
          wordBreak: 'break-all',
        }}
      >
        {fileName}
      </Link>
    </div>
  );
})}

       
    </div>
  )
}

export default Resources
